module.exports = __webpack_public_path__ + "img/스트라이커.166ad8b0.png";